export enum TransactionStatus {
  New,
  Mining,
  Success,
  Fail,
}
